import { createSlice } from "@reduxjs/toolkit";



const privilegeSlice = createSlice({
    name : 'privilege',
    initialState : {
        privilege : {},
        status : 'idle',
        deletedPrivilege: [],
        allPrivilege : [],
        adminActivity : {}
    },
    reducers : {
        setUserPrivileges(state, action){
            // (state.privilege).push(action.payload)
            state.privilege = action.payload
        },
        setStatus(state:any, action:any){
            state.status = action.payload
        },
        removeUserPrivileges(state, action){
            // (state.deletedPrivilege).push(action.payload)
            state.deletedPrivilege = action.payload
        },
        setAllUserPrivileges(state:any, action:any) {
            (state.allPrivilege).push(action.payload)
        },
        setAdminActivity(state, action) {
            state.adminActivity = action.payload
        }
    }
})


export const {setUserPrivileges, setStatus, removeUserPrivileges, setAllUserPrivileges, setAdminActivity} = privilegeSlice.actions;
export default privilegeSlice.reducer;